"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.delete.confirm.title': 'Usuń Zawód',
    'profession.delete.confirm.message': 'Czy na pewno chcesz usunąć ten zawód?',
};
